"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AAS Template repository API
 * The API implemented by the AAS repository
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceType = void 0;
/**
 * The type of resource associated with \'resourceId\'
 * @export
 * @enum {string}
 */
var ResourceType;
(function (ResourceType) {
    ResourceType["Group"] = "group";
    ResourceType["Template"] = "template";
    ResourceType["Label"] = "label";
    ResourceType["Platform"] = "platform";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
//# sourceMappingURL=resource-type.js.map